import React from 'react';
import TreeLogo from './TreeLogo';

const Nav = () => (
  <header
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 50,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '24px',
      padding: '20px 56px',
      background:
        'linear-gradient(180deg, rgba(5,7,10,0.92) 0%, rgba(5,7,10,0.6) 60%, rgba(5,7,10,0) 100%)',
      backdropFilter: 'blur(2px)',
      WebkitBackdropFilter: 'blur(2px)',
    }}
    className="zk-nav-bar"
  >
    <a
      href="#top"
      data-zk-logo
      style={{
        position: 'relative',
        textDecoration: 'none',
        color: 'inherit',
        display: 'flex',
        alignItems: 'center',
        gap: '11px',
      }}
      aria-label="Zohtek home"
    >
      <TreeLogo gradientId="zk-nav-grad" />
      <span
        style={{
          position: 'relative',
          zIndex: 1,
          display: 'inline-block',
          width: '9px',
          height: '9px',
          borderRadius: '50%',
          background: '#ff3ea5',
          boxShadow: '0 0 12px #ff3ea5',
        }}
      />
      <span
        style={{
          position: 'relative',
          zIndex: 1,
          fontWeight: 700,
          fontSize: '21px',
          letterSpacing: '0.17em',
        }}
      >
        ZOHTEK
      </span>
    </a>

    <div style={{ display: 'flex', alignItems: 'center', gap: '34px', fontSize: '14px' }}>
      <nav
        className="zk-nav-links"
        style={{ display: 'flex', alignItems: 'center', gap: '34px' }}
      >
        <a href="#services" className="zk-nav-link" style={{ textDecoration: 'none' }}>
          Services
        </a>
        <a href="#rates" className="zk-nav-link" style={{ textDecoration: 'none' }}>
          Rates
        </a>
        <a href="#about" className="zk-nav-link" style={{ textDecoration: 'none' }}>
          About
        </a>
        <a href="#contact" className="zk-nav-link" style={{ textDecoration: 'none' }}>
          Contact
        </a>
      </nav>
      <a href="#contact" className="zk-cta-pink zk-cta-desktop">
        [ START_A_CONVERSATION ]
      </a>
      <a href="#contact" className="zk-cta-pink zk-cta-mobile" aria-label="Contact">
        [ TALK ]
      </a>
    </div>
  </header>
);

export default Nav;
